export const tradeSiteEnabled = () => process.env.REACT_APP_TOGGLE_TRADE_SITE === '1';

export const tradeSiteDisabled = () => !tradeSiteEnabled();

export const TradeSiteOnly = ({ children }) => (tradeSiteEnabled() ? children : null);

export const SkipIfTradeSite = ({ children }) => (tradeSiteDisabled() ? children : null);



// WEBPACK FOOTER //
// ./src/utils/toggles.js